export const whitespace = /\s/;
